{
  "CONFIRMATION__PAGE__TITLE": "Confirmation",
  "DOCUMENTS__ACCESS_EXPIRES_IN_X_DAYS": "Access expires in {{days}} day(s)",
  "DOCUMENTS__DOWNLOAD_ALL": "Download all",
  "DOCUMENTS__EXPIRED__DESCRIPTION": "The documents you are trying to view are no longer available. Please ask your contact person to resend the documents.",
  "DOCUMENTS__EXPIRED__TITLE": "Document(s) no longer available",
  "DOCUMENTS__OVERVIEW__PAGE__TITLE": "Overview",
  "DOCUMENTS__PAGE__TITLE": "Documents",
  "DOCUMENTS__TITLE": "Documents",
  "DOWNLOAD": "Download",
  "FORMS__ERROR__MIN_LENGTH": "Enter a minimum of {{minlength}} characters",
  "FORMS__ERROR__REQUIRED": "Required",
  "LOGIN__CODE": "Code",
  "LOGIN__DESCRIPTION": "We’ve delivered a security code to the designated phone number. Please enter the code to complete verification.",
  "LOGIN__PAGE__TITLE": "Login",
  "LOGIN__RESEND_CODE": "Resend code",
  "LOGIN__RESEND_COOLDOWN": "Please wait {{seconds}} more seconds before trying again",
  "LOGIN__SUBMIT": "View documents",
  "LOGIN__TITLE": "Enter security code",
  "LOGIN_FAILED__TOO_MANY_REQUESTS": "Please wait a moment before trying again.",
  "LOGIN_FAILED__TOO_MANY_REQUESTS__TITLE": "Too many verification attempts",
  "LOGIN_FAILED__UNAUTHORIZED": "Access denied. Please verify that your code has been entered correctly.",
  "LOGOUT": "Logout",
  "NO_PREVIEW": "No preview",
  "PAGE_NOT_FOUND": "Page not found",
  "UNKNOWN_ERROR__TEXT": "If the problem persists, please contact the sender of the document.",
  "UNKNOWN_ERROR__TITLE": "Unknown error",
  "VERIFICATION__BUTTON": "Start verification",
  "VERIFICATION__DESCRIPTION": "To view the documents, please verify your identity using the phone number below. You will receive a one-time code via SMS or phone call. Enter this code to complete the verification.",
  "VERIFICATION__ERROR__DESCRIPTION": "If the problem persists, please contact the sender of the document.",
  "VERIFICATION__ERROR__TITLE": "Something went wrong",
  "VERIFICATION__PAGE__TITLE": "Verification",
  "VERIFICATION__TITLE": "A document has been shared with you."
}
